/**
 * TealerLab — Bootstrap
 * Charge l'event bus, l'AI Hub, Klaviyo, et tous les WC custom TealerLab.
 * Importé en module non-bloquant depuis theme.liquid via tlr-head.liquid.
 */

import "@theme/tlr-events";
import "@theme/tlr-ai-hub";
import "@theme/tlr-klaviyo";
import "@theme/tlr-notify";
import "@theme/tlr-variant-grammage";
import "@theme/tlr-wishlist";
// NOTE: tlr-cart-samples module retiré (legacy, logique migrée dans tlr-cart-drawer.js).
// L'import cassé causait "TypeError: Failed to resolve module specifier" → Best Practices KO.
import "@theme/tlr-cart-recos";
import "@theme/tlr-recent-purchases";
import "@theme/tlr-stock-indicator";

// Auto-mount recent-purchases (global, fires only on storefront, never editor)
if (!window.Shopify?.designMode && !document.querySelector("tlr-recent-purchases")) {
  const rp = document.createElement("tlr-recent-purchases");
  document.body.appendChild(rp);
}

import { tlrEvents } from "@theme/tlr-events";

// Bridges Horizon → tlr events bus
// Horizon dispatch des CustomEvents sur document via @theme/events.
// On les écoute et on rebroadcast dans notre namespace.
const HORIZON_TO_TLR = {
  "cart:item:added": "add_to_cart",
  "cart:item:removed": "remove_from_cart",
  "cart:updated": "view_cart",
  "variant:change": "select_item",
  "search:submit": "search",
};

for (const [hzn, tlr] of Object.entries(HORIZON_TO_TLR)) {
  document.addEventListener(hzn, (e) => {
    tlrEvents.emit(tlr, e.detail || {});
  });
}

// On émet view_item dès que la PDP est rendue
document.addEventListener("DOMContentLoaded", () => {
  const main = document.getElementById("MainContent");
  const template = main?.dataset?.template;
  if (template === "product" && window.tlr?.product) {
    tlrEvents.emit("view_item", window.tlr.product);
  }
  if (template?.startsWith("collection") && window.tlr?.collection) {
    tlrEvents.emit("view_item_list", window.tlr.collection);
  }
});

// Ready signal
window.tlr = window.tlr || {};
window.tlr.ready = true;
window.dispatchEvent(new CustomEvent("tlr:ready"));
